import { sanitizeFilter, isSystemFilter } from './filterManager';
import { SavedSearchConfiguration } from '../types';

export const getTableConfig = (table: any, filterShowExceptions: string[] = [], currentConfig: any = null): SavedSearchConfiguration => {
    if (!table) {
        return {
            filters: { logic: 'and', filters: [] },
            columns: { visible: [], hidden: [] },
            sorting: { orderBy: null, order: 'asc' },
            pagination: { pageSize: 25 }
        };
    }

    let filters: { logic: 'and' | 'or'; filters: any[] } = { logic: 'and', filters: [] };
    if (table.state && table.state.filter) {
        const sanitized = sanitizeFilter(table.state.filter);

        // Filter out system filters - they should never be saved
        if (sanitized && sanitized.filters) {
            filters = {
                logic: (sanitized.logic as 'and' | 'or') || 'and',
                filters: sanitized.filters.filter((f: any) => !isSystemFilter(f))
            };
        } else {
            filters = { ...sanitized, logic: (sanitized.logic as 'and' | 'or') || 'and' };
        }
    }

    const columns: { visible: string[]; hidden: string[] } = { visible: [], hidden: [] };
    if (table.config && table.config.columns) {
        table.config.columns.forEach((col: any) => {
            const colId = col.id || col.command;
            if (colId && col.toggleable) {
                if (table.extensions && table.extensions.isColumnHidden && table.extensions.isColumnHidden(col)) {
                    columns.hidden.push(colId);
                } else {
                    columns.visible.push(colId);
                }
            }
        });
    }

    const sorting = {
        orderBy: table.state?.orderBy || null,
        order: table.state?.order || 'asc'
    };

    const pagination = {
        pageSize: table.state?.rowsPerPage || 25,
        page: table.state?.page || 0
    };

    // Prefer term from currentConfig if available, otherwise fall back to table.config
    const searchTerm = currentConfig?.term !== undefined ? currentConfig.term : (table.config?.term || '');

    // Include custom fields if present
    const customFields = currentConfig?.customFields || table.config?.customFields || {};

    return {
        filters,
        columns,
        sorting,
        pagination,
        searchTerm,
        customFields
    };
};
